import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Protected from "@/components/Protected";
import Gate from "@/pages/Gate";
import Login from "@/pages/Login";
import Billing from "@/pages/Billing";
import ResetPassword from "@/pages/ResetPassword";
import FounderConsole from "@/pages/founder/FounderConsole";
import AdminConsole from "@/pages/admin/AdminConsole";
import DataCollection from "@/pages/m1/DataCollection";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Gate />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset" element={<ResetPassword />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/platform/*" element={<Protected requirePlatform><FounderConsole /></Protected>} />
            <Route path="/admin/*" element={<Protected requireAdmin><AdminConsole /></Protected>} />
            <Route path="/m1/*" element={<Protected requireModule="module_1"><DataCollection /></Protected>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
